import React, { useState } from "react";
import ContactPopupWidget from "./ContactPopupWidget.jsx";

const ContactWidget = ({ config }) => {
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [showRoleRequired, setShowRoleRequired] = useState(false);
  const loginPopUp = document.getElementById("login-popup-wrapper");

  const has_role_permission =
    config.has_role_contact_permission.toLowerCase() === "true";

  const handleOpenPopUp = () => {
    if (!has_role_permission) {
      //Si hay declarado un rol requerido chequea la condicion
      setShowRoleRequired(true);
    } else {
      setIsPopUpOpen(true);
    }
  };

  const showLoginPopUp = () => {
    if (loginPopUp) {
      const modal = new bootstrap.Modal(loginPopUp);
      modal.show();
    }
  };
  return (
    <>
      <div className="card w-100 p-4 shadow-sm card-border-left min-height-16em height-100 d-flex flex-column align-items-start justify-content-center">
        <i className="fa-solid fa-paper-plane text-primary fs-1 mb-4"></i>
        <h4 className="section__title--float h4">{config.translations.contactTitle}</h4>
        <p> {config.translations.contactSubTitle}</p>
        <button
          onClick={
            config.profile === ""
              ? () => showLoginPopUp()
              : () => handleOpenPopUp()
          }
          className="btn btn-primary"
        >
          <i className="fa-regular fa-comment"></i>{" "}
          {config.translations.contactTxtBtn}
        </button>
        <p className="ContactWidget_roleWarning">
          {showRoleRequired && config.translations.contactNoPermission}
        </p>
      </div>
      {isPopUpOpen && ( //obligar a desmontar el componenete, porque sino el modal de bootstrap solo lo pone hidden
        <ContactPopupWidget
          onHide={() => setIsPopUpOpen(false)}
          show={isPopUpOpen}
          config={config}
        />
      )}
    </>
  );
};

export default ContactWidget;
